import React from 'react';
import {Router, Route, IndexRoute, Redirect} from 'react-router';
import {loggedIn} from 'util/Authentication';
import History from 'util/History';
import Theme from 'util/Theme';
import Login from 'login/Login';
import NavigationView from 'navigation/views/NavigationView';
import ResetPassword from 'login/ResetPassword';
import ForgotPassword from 'login/ForgotPassword';
import FirstTimeLoginReset from 'login/FirstTimeLoginReset';
import ProjectLobbyView from 'Projects';
import CnsProcedureLobbyView from 'CnsProcedureLobby';
import ImportedProcedureUpdateCreateContainer from 'ImportedProcedureUpdateCreate';
import ImportedProjectSuiteView from 'ImportedProjectSuite';
import ImportedProcedureLobbyView from 'ImportedProcedureLobby';
import UserLobbyView from 'UserLobby';
import CustomiseProjectView from 'CustomiseProject';
import ImportedProjectLobbyView from 'ImportedProjectLobby';
import UserUpdateCreateView from 'UserUpdateCreate/views/UserUpdateCreateView';

function requireAuth(nextState, replace) {
  if (!loggedIn()) {
    replace({
      pathname: '/login',
      state: {nextPathname: nextState.location.pathname},
    });
  }
}

const routes = (
  <Route>
    <Route path="login" component={Login} />
    <Route path="reset-password" component={ResetPassword} />
    <Route path="forgot-password" component={ForgotPassword} />
    <Route path="new-password" component={FirstTimeLoginReset} />

    <Route path="/" component={NavigationView} onEnter={requireAuth}>
      <IndexRoute component={ImportedProjectLobbyView} />
      <Route path="Projects">
        <IndexRoute component={ImportedProjectLobbyView} />
        <Route path="import" component={ProjectLobbyView} />
        <Route path=":importedProjectId" component={ImportedProjectSuiteView} />
      </Route>
      <Route path="Procedures">
        <IndexRoute component={ImportedProcedureLobbyView} />
        <Route path="import" component={CnsProcedureLobbyView} />
        <Route path="create" component={ImportedProcedureUpdateCreateContainer} />
        <Route
          path=":importedProcedureId/update"
          component={ImportedProcedureUpdateCreateContainer}
        />
        <Route
          path=":importedProcedureId/import"
          component={ImportedProcedureUpdateCreateContainer}
        />
      </Route>
      <Route path="CustomiseProject">
        <Route path=":importedProjectId" component={CustomiseProjectView} />
      </Route>
      <Route path="Users">
        <IndexRoute component={UserLobbyView} />
        <Route path="create" component={UserUpdateCreateView} />
        <Route path=":userId/update" component={UserUpdateCreateView} />
      </Route>
      <Redirect from="*" to="/Projects" />
    </Route>
  </Route>
);
const RouterExport = () => (
  <Theme>
    <Router history={History} routes={routes} />
  </Theme>
);

export default RouterExport;
